<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <JssRichText class="events-detail-title" :field="fields?.title" tag="h1" />
      <JssRichText class="events-detail-subtitle" :field="fields?.subtitle" />
      <div class="events-detail-share">
        <div class="events-detail-share-lt">
          <div
            v-for="(item, index) in fields?.list"
            :key="index"
            class="events-detail-share-lt-item"
          >
            <Icon :svg="item?.fields?.icon?.value?.svgCode" />
            <JssRichText class="events-detail-share-lt-item-desc" :field="item?.fields?.text" />
          </div>
        </div>
      </div>
      <JssRichText class="events-detail-body" :field="fields?.body" tag="div" />
    </ContentGrid>
  </div>
</template>

<script>
import utils from '@/utils';

export default {
  name: 'EventsDetail',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
    page: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const rootClass = utils.overall.baseComClass(props.fields, 'events-detail');

    const rootStyle = utils.overall.baseComStyle(props.fields);

    const formatDate = (dateStr) => {
      if (!dateStr) return '';
      const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return dateStr;
      const month = months[date.getMonth()];
      const day = date.getDate();
      const year = date.getFullYear();
      return `${month} ${day}, ${year}`;
    };

    return {
      rootClass,
      rootStyle,
      formatDate,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.events-detail {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-tag {
    font-size: 14px;
    line-height: 1.4;
    color: $blue-night;
    padding: 4px 16px;
    background: #f1f4f1;
    border-radius: 32px;
    display: inline-block;
  }

  &-title {
    margin-top: 16px;
    font-size: 16px;
  }

  &-subtitle {
    margin-top: 16px;
    font-size: 14px;
  }

  &-share {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;

    &-lt {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;

      &-item {
        display: flex;
        align-items: center;
        gap: 4px;
        svg {
          fill: transparent;
        }
        &-desc {
          font-size: 14px;
          line-height: 1.4;
          color: #656565;
        }
      }
    }
  }

  &-body {
    margin-top: 24px;
    img {
      max-width: 100% !important;
    }
    p {
      font-size: 16px;
    }
    h2 {
      font-size: 22px;
      color: $blue-night;
      margin: 16px 0;
    }
    a {
      color: $blue-night;
    }
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-title {
      margin-top: 24px;
      font-size: 32px;
    }

    &-subtitle {
      margin-top: 16px;
      font-size: 16px;
    }

    &-share {
      margin-top: 30px;

      &-lt {
        flex-direction: row;
        align-items: center;
      }
    }

    &-body {
      margin-top: 40px;
    }
  }
}
</style>
